import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { AppCustomPreloader } from './app-custom-preloader';
import { environment } from '../environments/environment';

import { Routes, Router } from '@angular/router';

//import { WelcomeComponent } from './welcome.component';
const routes: Routes = [
  // @if NODE_ENV='all'
 // { path: 'welcome', component: WelcomeComponent },
  
];
@NgModule({
  imports: [
    RouterModule.forRoot(environment.routes, { preloadingStrategy: AppCustomPreloader }),
  ],
  exports: [RouterModule],
  providers: [AppCustomPreloader],
})
export class AppRoutingModule {}
